const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot%20quality&width=100&height=100&seq=avatar-reader-01&orientation=squarish',
    name: '小樱同学',
    date: '2026年7月25日',
    rating: 5,
    text: '蛙漫漫画真的是我见过最全的漫画平台了！韩漫更新速度超快，画质也很清晰。每天晚上睡前必刷，已经成了我的日常习惯。强烈推荐给所有漫画爱好者！',
    comic: '《霸道总裁的契约新娘》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20man%20with%20friendly%20expression%2C%20casual%20modern%20style%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-reader-02&orientation=squarish',
    name: '追漫少年阿飞',
    date: '2026年7月22日',
    rating: 5,
    text: '日漫分类做得太好了，找漫画很方便。而且完全免费，不用充会员也能看全部内容。界面干净没有乱七八糟的广告，阅读体验一级棒！',
    comic: '《咒术回战》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20woman%20with%20gentle%20smile%2C%20stylish%20casual%20look%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20background%2C%20natural%20headshot&width=100&height=100&seq=avatar-reader-03&orientation=squarish',
    name: '月光下的喵',
    date: '2026年7月20日',
    rating: 5,
    text: '国漫板块越来越丰富了！好多优秀的国产漫画都能在这里找到。APP端的夜间模式特别贴心，晚上看漫画眼睛也不会累。蛙漫，继续加油！',
    comic: '《斗破苍穹》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20man%20with%20bright%20smile%2C%20casual%20street%20style%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20genuine%20headshot&width=100&height=100&seq=avatar-reader-04&orientation=squarish',
    name: '漫画探险家',
    date: '2026年7月18日',
    rating: 5,
    text: '从小就看漫画，用过很多平台，蛙漫是体验最好的。分类索引功能让我发现了很多冷门好作品。每天都会来看看更新榜单，已经离不开了！',
    comic: '《我独自升级》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            读者心声
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            听听蛙漫读者怎么说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            来自真实读者的真诚评价，是我们不断前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.name}
              className="p-5 rounded-2xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.text}
              </p>
              <div className="text-xs text-primary-600 font-medium">
                正在阅读：{item.comic}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}